import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function CrewsEditManagerList(props) {
    //console.debug("RTS Break CrewsEditManager");

    const {sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [crewLead, setCrewLead] = useState(null);
    const [repoData, setRepoData] = useState([]);

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const fetchData = useCallback((pFilter) => {
        let apiURL = apiRoot + "/AppUserCustomers/GetCustomerCrewLeads/" + pFilter;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setRepoData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token]);

    
    useEffect(() => {
        setCrewLead(props.crewLead);
        fetchData(sessionCustomer.customer.idGuid);
    }, [props, fetchData, sessionCustomer]); 


    function valChange(e, val){
        props.setCrewLeadFx(val);
        setCrewLead(val);
        props.setFormDirtyFx(1);
    }


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <>
            <Autocomplete
                options={repoData}
                renderInput={(params) => <TextField {...params} label="Crew Lead" margin="normal" size="small" />}
                value={crewLead}
                onChange={valChange}
                getOptionLabel={(curValue) => curValue!=null?curValue!==''?curValue.firstName + ' ' + curValue.lastName:'':''}
                renderOption={(props, curValue) => (
                    <Box component="li" {...props} key={curValue.userName}>
                        {curValue.firstName + ' ' + curValue.lastName}
                    </Box>
                )}
                isOptionEqualToValue={(option, value) => option.userName === value.userName}
            />
        </>
    );
}

